import React from 'react';
import Modal from '../../../../../../../components/Modal';
import html2pdf from 'html2pdf.js';

const Modals = ({ details, isOpen, onClose }) => {
  const handlePrint = async () => {
    const options = {
      margin: 60,
      filename: details?.title.replace(/\s/g, '') + '.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 3 },
      jsPDF: { unit: 'pt', format: 'a3', orientation: 'portrait' }
    };
    
    const contentWrapper = document.getElementById('standardcontent');
    const contentClone = contentWrapper.cloneNode(true);
  
    // Create and style the h3 tag
    const h3Tag = document.createElement('h3');
    h3Tag.textContent = details?.title;
    h3Tag.style.fontSize = '1.125rem';

    h3Tag.style.fontWeight = '500';
    
    // Add spacing between h3 and border
    h3Tag.style.marginBottom = '15px';
    h3Tag.style.paddingBottom = '15px';
    
    // Add border style
    h3Tag.style.borderBottom = '2px solid #e7edff';
    
    contentClone.insertBefore(h3Tag, contentClone.firstChild);
    const button = contentClone.querySelector('#printButton');
    button.style.display = 'none';

    await html2pdf().set(options).from(contentClone).save(options.filename);
  };
  

  return (
    <Modal titleName={details?.title} isOpen={isOpen} onClose={onClose}>
      <div id="standardcontent" className="d-flex flex-column gap-2">
        <div className="m-2">
          <strong>{details?.subTitle}</strong>
        </div>

        <div dangerouslySetInnerHTML={{ __html: details?.description }}></div>
        <div className="d-flex justify-content-center">
          <button id="printButton" onClick={handlePrint} className="btn btn-castleWhite">
            Print
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default Modals;
